import { useMemo } from 'react';
import { useDemoLiveActivities } from './hooks/demoLiveActivities';
import MipActivityTile from './MipActivityTile';
import { LiveViewLayout } from './LiveViewLayout';
import type { ActivityRecording } from './ActivityTile';

interface DemoLiveViewProps {
  organisationId: string;
  jobsiteId: string;
}

export default function DemoLiveView({ organisationId, jobsiteId }: DemoLiveViewProps) {
  const { isCameraOnline, activities } = useDemoLiveActivities(jobsiteId);

  const sorted = useMemo(
    () => [...activities].sort((a, b) => b.displayedCaptureStartAt.localeCompare(a.displayedCaptureStartAt)),
    [activities]
  );

  const overviewRecordings = useMemo<ActivityRecording[]>(
    () =>
      sorted.map((a) => ({
        id: a.id,
        captureStartAt: a.displayedCaptureStartAt,
        imageStatus: a.imageStatus,
        materialStatus: a.materialStatus,
        soilStatus: a.soilStatus,
        volumeStatus: a.volumeStatus,
        edgeStatus: a.edgeStatus,
        licensePlateStatus: a.licensePlateStatus,
        licensePlate: a.licensePlate || '',
      })),
    [sorted]
  );

  const liveViewActivities = useMemo(
    () =>
      sorted.map((activity) => ({
        id: activity.id,
        captureStartAt: activity.displayedCaptureStartAt,
        renderTile: (isFocus: boolean) => (
          <MipActivityTile
            organisationId={organisationId}
            jobsiteId={jobsiteId}
            recording={activity}
            isFocus={isFocus}
          />
        ),
      })),
    [sorted, jobsiteId, organisationId]
  );

  return (
    <LiveViewLayout
      jobsiteId={jobsiteId}
      isCameraOnline={isCameraOnline}
      activities={liveViewActivities}
      overviewRecordings={overviewRecordings}
      licensePlates={{}}
    />
  );
}
